import { DefaultApi } from '../autogenerated/spdApiClient/apis/DefaultApi';
import { GridRecord } from '../../components/Grid/GridDataTypes';
import { validateAgainst } from '../validation/validateAgainst';
import {
  CreateUpdatePricingGroupDto,
  CreateUpdatePricingGroupDtoFromJSON,
  GetPricingGroupDto,
} from '../autogenerated/spdApiClient';
import { pricingGroupForGrid } from '../../../spd/components/PricingGroup/PricingGroupSearch';
import { PricingGroupSchema } from '../validation/schemas';

export interface PricingGroupContextInterface {
  get: (id: string) => Promise<GetPricingGroupDto>;
  getAll: () => Promise<GetPricingGroupDto[]>;
  getAllCount: (filterText?: string) => Promise<number>;
  getAllByPortion: (
    pageSize: number,
    pageNumber: number,
    orderBy?: string,
    orderDirection?: string,
    filterText?: string,
  ) => Promise<GridRecord[]>;
  update: (id: string, dto: CreateUpdatePricingGroupDto) => Promise<void>;
  create: (dto: CreateUpdatePricingGroupDto) => Promise<GetPricingGroupDto>;
}

export const PricingGroupContext = (api: DefaultApi) => {
  return {
    get: async (id: string) => {
      return await api.pricingGroupControllerGet(id);
    },

    getAll: () => api.pricingGroupControllerGetAll(),

    getAllByPortion: async (
      pageSize: number,
      pageNumber: number,
      orderBy?: string,
      orderDirection?: string,
      filterText?: string,
    ) => {
      const data = await api.pricingGroupControllerGetAllByPortion(
        pageSize,
        pageNumber,
        orderBy || '',
        orderDirection || '',
        filterText || '',
      );
      return data.map(pricingGroupForGrid);
    },

    getAllCount: (filterText?: string) =>
      api.pricingGroupControllerGetAllCount(filterText || ''),

    update: (id: string, dto: CreateUpdatePricingGroupDto) =>
      api.pricingGroupControllerUpdate(id, dto),

    create: (dto: CreateUpdatePricingGroupDto) =>
      api.pricingGroupControllerCreate(dto),
  };
};

export const validate = (pricingGroup: CreateUpdatePricingGroupDto) => {
  return validateAgainst(PricingGroupSchema, pricingGroup);
};

export const pricingGroupData = (
  pricingGroup?: GetPricingGroupDto,
): CreateUpdatePricingGroupDto => {
  if (!pricingGroup) {
    return CreateUpdatePricingGroupDtoFromJSON({ active: true });
  }
  return CreateUpdatePricingGroupDtoFromJSON({
    ...pricingGroup,
  });
};
